import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lastNameFormat',
})
export class LastNameFormatPipe implements PipeTransform {

  transform(value: string, ...args) {
    let lastName = value.split(' ');
    lastName = lastName.filter( s => s ).map( s => s.toUpperCase() );

    return `${lastName.shift()[0]}.`;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/last-name-format/last-name-format.ts